import {formatUnitsValue} from "./unitsHelper";

/**
 * Class to handle the product's units
 */
const MULTIPLIERS = {
    KG: 1000,
    UN: 1
};

export default class Units {
    /**
     * @param {number} qty - the units value
     * @param {string} unit - the units unit
     */
    constructor(qty, unit) {
        const allowedUnits = ["kg", "un"];

        this.unitLabel = (allowedUnits.includes(unit)) ? unit : "un";
        this.multiplier = (this.unitLabel === "kg") ? MULTIPLIERS.KG : MULTIPLIERS.UN;
        this.value = (this.unitLabel === "kg") ? qty * this.multiplier : parseInt(qty, 10);
    }

    /**
     * Returns the Units value
     */
    getValue() {
        return this.value / this.multiplier;
    }

    /**
     * Sets the Units value
     * @param {number} val - the new units value
     */
    setValue(val) {
        this.value = val * this.multiplier;
    }

    /**
     * Adds to the Units value
     * @param {Units} units - the units to be added
     */
    add(units) {
        if (this.unitLabel === units.unitLabel) {
            this.value = this.value + units.value;
        }
    }

    /**
     * Subtracts from the Units value
     * @param {Units} units - the units to be subtracted
     */
    subtract(units) {
        if (this.unitLabel === units.unitLabel) {
            this.value = this.value - units.value;
        }
    }

    /**
     * Gets the formatted Units value
     * @return {string} - the formatted units value
     */
    getDisplayValue() {
        return formatUnitsValue(this);
    }
}
